var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blacklist-wrapper",class:{'default': !_vm.hasBlacklist}},[(_vm.hasBlacklist)?_c('div',_vm._l((_vm.blacklist),function(item){return _c('blacklist-item',{key:item.userID,attrs:{"profile":item}})}),1):_c('span',{staticStyle:{"color":"gray"}},[_vm._v("黑名单还是空的")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60309aae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/im/blacklist/blacklist.vue
// module id = null
// module chunks = 